import { render, staticRenderFns } from "./DashboardFilters.vue?vue&type=template&id=1fdf1a58&scoped=true&"
import script from "./DashboardFilters.vue?vue&type=script&lang=js&"
export * from "./DashboardFilters.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFilters.vue?vue&type=style&index=0&id=1fdf1a58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdf1a58",
  null
  
)

export default component.exports